// Some native/web transports do not settle when aborted after suspension.
// Release the caller independently, while consuming any late resolution or
// rejection. The operation itself still receives the same signal and must
// check ownership before applying side effects.
export function abortable(promise, signal, abortError) {
  return new Promise((resolve, reject) => {
    let settled = false;
    const finish = (complete, value) => {
      if (settled) return;
      settled = true;
      signal.removeEventListener('abort', cancel);
      complete(value);
    };
    const cancel = () => finish(reject, abortError || new Error('AUTH_TIMEOUT'));
    // Consume late errors too, but release our listener immediately when the
    // caller cancels. The underlying transport may never settle after suspend.
    Promise.resolve(promise).then(value => finish(resolve, value), error => finish(reject, error));
    if (signal.aborted) { cancel(); return; }
    signal.addEventListener('abort', cancel, { once: true });
  });
}
